import { useIntl, defineMessages } from 'react-intl'
import { Text } from '@homebotapp/hb-react-component-catalog'
import BotHead from '../../../../../Components/shared/Avatar/BotHeadColored'

export const MSG = defineMessages({
  error: {
    id: 'BombBomb.panel.video.error',
    defaultMessage: 'BombBomb failed to load'
  }
})

export const BombBombPanelVideoError = () => {
  const intl = useIntl()

  return (
    <>
      <BotHead quizzical type='error' size='l' />
      <Text as='i' size='sm' color='warning' display='block' textAlign='left'>
        {intl.formatMessage(MSG.error)}
      </Text>
    </>
  )
}
